<template>
  <main class="about">
    <div class="col">
      <h2>{{ about.title }}</h2>
      <div class="txt" v-html="about.text" />
    </div>
    <div class="col">
      <h2>AWARDS</h2>
      <div v-for="award in about.awards" :key="award.id" class="item">
        <div class="year txt">{{ award.year }}</div>
        <div class="title txt">{{ award.title }}</div>
      </div>
      <br />
      <h2>EXHIBITIONS</h2>
      <div
        v-for="exhibition in about.exhibitions"
        :key="exhibition.id"
        class="item"
      >
        <div class="year txt">{{ exhibition.year }}</div>
        <div class="title txt">{{ exhibition.title }}</div>
      </div>
      <br />
      <h2>PROJECTS</h2>
      <div v-for="project in about.projects" :key="project.id" class="item">
        <a
          v-if="project.file.length > 0"
          class="item"
          :href="project.file"
          target="_blank"
        >
          <div class="year txt">{{ project.year }}</div>
          <div class="title txt">{{ project.title }}</div>
        </a>
        <div v-else class="item">
          <div class="year txt">{{ project.year }}</div>
          <div class="title txt">{{ project.title }}</div>
        </div>
      </div>
    </div>
    <div class="col">
      <h2>POST</h2>
      <div class="txt" v-html="about.post" />
      <h2>PHONE</h2>
      <div class="txt" v-html="about.phone" />
      <h2>MAIL</h2>
      <div class="txt">
        <a href="mailto:info@estellebourdet.com">{{ about.mail }}</a
        ><br /><br />
      </div>
      <h2>INSTAGRAM</h2>
      <div class="txt" v-html="about.instagram" />
      <h2>CREDITS</h2>
      <div class="txt" v-html="about.credits" />
    </div>
  </main>
</template>

<script>
export default {
  name: "about",
  computed: {
    about() {
      return this.$store.state.about;
    }
  },
  metaInfo() {
    return {
      title: "– About"
    };
  }
};
</script>

<style lang="scss">
.about {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: 1em;
  @media only screen and (max-width: 768px) {
    grid-template-columns: repeat(1, 1fr);
  }
  p {
    letter-spacing: 0.1em !important;
  }
  .col {
    grid-column: span 1;
    .item {
      display: flex;
      .year {
        flex: 0 0 auto;
        padding-right: 1em;
        font-feature-settings: "tnum";
      }
      .title {
        flex: 1 1 auto;
      }
    }
    .txt {
      text-transform: none;
      letter-spacing: 0.1em;
      padding-right: 0.5em;
      p {
        margin-bottom: 1em !important;
      }
      a {
        transition: letter-spacing 0.2s;
        &:hover {
          letter-spacing: 0.4em;
        }
      }
    }
  }
}
</style>
